import React, { Fragment } from 'react';
import Search from '../Search';
import RecentInteractions from '../RecentInteractions';
import Banner from './Banner';
import { useTeacherSearchContext } from '../../providers/TeacherSearchProvider';
import { verticalCopy } from '../../utils/constants/verticalCopy';
import './Home.css';

const HOME_VERTICALS = ['university', 'languages', 'schools'] as const;

const Home = () => {
  const { searchType, setSearchType } = useTeacherSearchContext();
  const copy = verticalCopy[searchType === 'all' ? 'university' : searchType];

  return (
    <Fragment>
      <div className="home">
        <div className="homeHeroCopy">
          <span className="homeTitle">
            Encontrá tu&nbsp;<span className="titleHighlight">profe</span>&nbsp;ideal
          </span>
          <span className="homeSubtitle">{copy.subtitle}</span>
        </div>
        <div className="homeSearch">
          <Search />
          <span className="homeContextHint">Estás buscando en: {copy.contextLabel}</span>
        </div>

        <div className="homeVerticalSwitch" role="tablist" aria-label="Elegí qué estás buscando">
          {HOME_VERTICALS.map((vertical) => (
            <button
              key={vertical}
              type="button"
              className={`homeVerticalOption ${
                searchType === vertical ? 'homeVerticalOptionActive' : ''
              }`}
              role="tab"
              aria-selected={searchType === vertical}
              onClick={() => {
                setSearchType(vertical);
              }}>
              <span className="homeVerticalOptionHeader">
                <span
                  className={`homeVerticalOptionRadio ${
                    searchType === vertical ? 'homeVerticalOptionRadioActive' : ''
                  }`}
                  aria-hidden="true"
                />
                <span className="homeVerticalOptionTitle">
                  {verticalCopy[vertical].homeOptionTitle}
                </span>
              </span>
              <span className="homeVerticalOptionSubtitle">
                {verticalCopy[vertical].homeOptionSubtitle}
              </span>
            </button>
          ))}
        </div>
        <span className="helpLink">
          Para saber más entra a nuestra <a href="/help">página de ayuda</a>.
        </span>
      </div>
      <RecentInteractions />
      <Banner />
    </Fragment>
  );
};

export default Home;
